export enum DefaultCtaListItems {
  BookOnline = 'book_online',
  Phone = 'phone',
  RequestForm = 'request_form',
  VirtualCare = 'virtual_care'
}
